import {
    MapperKeys,
    transformSourceToTargetKeys,
} from '@common/utils/query/dataMappers';
import { BackendTrack, FrameRate, Track } from '../types/media';

const TRACK_KEYS: MapperKeys<BackendTrack, Track> = {
    id: 'id',
    type: 'type',
    start: 'start',
    end: 'end',
    duration: 'duration',
    stitchCount: 'stitchCount',
    height: 'height',
    width: 'width',
    stitchX: 'stitchX',
    stitchY: 'stitchY',
    src: 'number',
    frameRate: 'number',
    mediaObjectId: 'mediaObjectTrackId',
    moiId: 'mediaObjectInstanceId',
    productionId: 'number',
};

export const mapBackendTracksToFrontend = (raw: BackendTrack): Track => {
    const transformed = transformSourceToTargetKeys(raw, TRACK_KEYS);

    const { denumerator, numerator, drop_frame } = raw.fps;
    const frameRate: FrameRate = {
        denumerator,
        numerator,
        dropFrames: drop_frame,
        fps: `${numerator}/${denumerator}`,
    };

    return {
        ...transformed,
        src: raw.hrefs.data,
        frameRate,
    };
};
